import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import store from './vuex/store'
import VueMask from 'di-vue-mask'
import { $can } from 'src/mixins/can'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import router from './router/router'

// library imports
import './assets/sass/style.scss'
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import * as VueGoogleMaps from 'vue2-google-maps'
// import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/pt-br')
// plugin setup
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCFy6ClNJe5tM8-s2UnDz8psFRe1XCm3T8',
    libraries: 'places' // This is required if you use the Autocomplete plugin
  }
})
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate, {events: 'change|keyup|blur'})
Vue.use(VueMask)
locale.use(lang)
Vue.use(VueMoment, {
  moment
})
Vue.mixin({
  methods: {
    $can
  }
})

Vue.filter('onlyNumbersMask', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.replace(/[a-zA-Z]|\s/, '')
})

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router
})

window.vm = vm



// WEBPACK FOOTER //
// ./src/main.js